import OneModal from "../OneModal/OneModal"
import OneTable from '../OneTable/OneTable'
import { Grid } from "@mui/material"

const HistoricoVisitasModal = ({ open, setOpen, dados }) => {
    const columns = [
        {
            name: 'Data',
            selector: row => row.data ? row.data : "Sem data",
            grow: 1.1
        },
        {
            name: 'Sentido',
            cell: row => row.sentido ? `${row.sentido}` : "",
            grow: 0.1,
            style: {
                display: 'flex',
                justifyContent: 'center'
            }
        },
        {
            name: 'Nome Morador',
            selector: row => row.nome ? `${row.nome}` : "",
            grow: 2
        },
        {
            name: 'Obs',
            selector: row => row.obs ? `${row.obs}` : "",
            grow: 2
        },
        {
            name: 'Apto',
            selector: row => row.imovel ? `${row.imovel}` : "",
            grow: 0.7
        }
    ]

    return (
        <>
            <OneModal
                open={open}
                setOpen={setOpen}
                titleText="Autorização de Entrada"
                fullWidth={true}
            >
                <Grid sx={{
                    backgroundColor: '#D9D9D9',
                    borderRadius: '5px',
                    display: 'flex',
                    flexGrow: 1,
                    height: '100%',
                    width: '100%'
                }}>
                    <OneTable data={dados} columns={columns} ></OneTable>

                </Grid>
            </OneModal>
        </>
    )
}

export default HistoricoVisitasModal
